import { Star } from "lucide-react";

export const Stars = ({ rating = 0, size = 14, className = "" }) => {
  const full = Math.floor(rating);
  const half = rating - full >= 0.5;
  return (
    <span className={`inline-flex items-center gap-0.5 ${className}`} aria-label={`${rating} out of 5`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const filled = i < full || (i === full && half);
        return (
          <Star
            key={i}
            style={{ width: size, height: size }}
            className={filled ? "fill-gold text-gold" : "text-gold/30"}
          />
        );
      })}
    </span>
  );
};
